import { m } from 'framer-motion';
import { Navigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { roles as ROLES } from 'src/utils/roles';

import { ForbiddenIllustration } from 'src/assets/illustrations';

import { varBounce, MotionContainer } from 'src/components/animate';

import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export function RoleBasedGuard({ children, roles, redirect = true, sx = {} }) {

  const { user } = useAuthContext();

  const isAdmin = user?.roles.includes(ROLES.ADMIN);
  const hasPermissions = roles.some(role => user?.roles.includes(role)) || isAdmin;

  if (typeof roles !== 'undefined' && !hasPermissions) {

    if (redirect) {
      return <Navigate to={paths.root} replace />;
    }

    return (
      <Container component={MotionContainer} sx={{ textAlign: 'center', py: { xs: 5, sm: 10 }, ...sx }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            Permission denied
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            You do not have permission to access this page.
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ my: { xs: 5, sm: 8 } }} />
        </m.div>

        <Button component={RouterLink} href="/" size="large" variant="contained" color="inherit">
          Go to home
        </Button>
      </Container>
    );
  }

  return <> {children} </>;
}
